export default "__VITE_ASSET__COY4VZkO__"